export const SET_PAGINATION = "SET_PAGINATION"
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER"
export const SET_DATA_IN_ONEPAGE = "SET_DATA_IN_ONEPAGE"
export const SET_DATA_IN_ONEPAGE_RESULT = "SET_DATA_IN_ONEPAGE_RESULT"
export const SET_TOTAL_NO_RESULT = "SET_TOTAL_NO_RESULT"

//===
export const SET_CURRENT_STEP = "SET_CURRENT_STEP"
export const SET_CLICK_STEP = "SET_CLICK_STEP"
export const SET_IS_SETTING_COACH_MARK = "SET_IS_SETTING_COACH_MARK"
//===